import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useAuth } from "../auth";
import { toast } from "sonner";

export default function SetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const emailFromLink = params.get("email") || "";
  const { setPassword: setPw } = useAuth();
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return toast.error("Password must be 8+ characters");
    if (password !== confirm) return toast.error("Passwords do not match");
    setBusy(true);
    try {
      const user = await setPw(token, password);
      toast.success("Welcome");
      if (user.role === "lead_client") nav("/trips");
      else nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invalid or expired link");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-16" data-testid="set-password-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <p className="tcm-eyebrow mb-4">Welcome to</p>
          <h1 className="font-display text-5xl tracking-tight mb-3">The Curated Mile</h1>
          <hr className="tcm-gold-rule w-16 mx-auto" />
          <p className="mt-6 text-sm text-[color:var(--tcm-navy-70)]">Set your password to enter your private portal.</p>
        </div>
        <div className="tcm-double-frame">
          <div className="tcm-inner p-8">
            <form onSubmit={submit} className="space-y-6" autoComplete="on">
              {/* Hidden username so the browser's password manager pairs this new password with the right account. */}
              <input type="email" name="email" autoComplete="username"
                     value={emailFromLink} readOnly aria-hidden="true" tabIndex={-1}
                     style={{position: "absolute", left: "-9999px", width: 1, height: 1, opacity: 0, pointerEvents: "none"}} />
              <div>
                <label className="tcm-eyebrow block mb-2" htmlFor="setpw-password">Password</label>
                <input id="setpw-password" name="password" autoComplete="new-password"
                       data-testid="setpw-password-input" type="password" className="tcm-input" required
                       value={password} onChange={(e) => setPassword(e.target.value)} />
              </div>
              <div>
                <label className="tcm-eyebrow block mb-2" htmlFor="setpw-confirm">Confirm password</label>
                <input id="setpw-confirm" name="confirm_password" autoComplete="new-password"
                       data-testid="setpw-confirm-input" type="password" className="tcm-input" required
                       value={confirm} onChange={(e) => setConfirm(e.target.value)} />
              </div>
              <button data-testid="setpw-submit-button" type="submit" disabled={busy} className="tcm-btn-primary w-full">
                {busy ? "Saving..." : "Set password"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
